import React from "react";
import "../ui/ui.scss";

/**
 * Separator — A thin dividing line (horizontal or vertical).
 *
 * Props:
 *   orientation — "horizontal" (default) | "vertical"
 *   className   — Extra class
 */
const Separator = ({ orientation = "horizontal", className = "" }) => (
  <div className={`ui-separator ui-separator--${orientation} ${className}`} />
);

export default Separator;
